import { Token } from '@/components/molecules'
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  VStack,
} from '@chakra-ui/react'
import { useForm } from 'react-hook-form'

export const FundSubscriptionForm = ({ onSubmit, setShowFund, ftnBalance }) => {
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm()

  return (
    <Box w={['auto', 'sm', 'md']}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack align={'center'}>
          <FormControl isInvalid={errors.amount}>
            <FormLabel htmlFor="amount" fontSize={'small'}>
              Add funds (FTN)
            </FormLabel>
            <HStack
              flexDir={['column', 'row']}
              alignItems={['stretch', 'flex-start']}
            >
              <VStack flex={1}>
                <Input
                  w={'full'}
                  borderColor={'primary.100'}
                  id="amount"
                  {...register('amount', {
                    required: 'This is required',
                    pattern: {
                      value: /^\d*\.?\d*$/,
                      message: 'Please enter a number',
                    },
                    validate: {
                      moreThanZero: (value) =>
                        value > 0 || 'The amount must be more than 0',
                      maxBalance: (value) => {
                        const valueExceedsBalance =
                          Number(value) <= Number(ftnBalance)

                        return (
                          valueExceedsBalance ||
                          `The amount cannot exceed ${ftnBalance} FTN`
                        )
                      },
                    },
                  })}
                />
                <Box
                  display={'flex'}
                  gap={1}
                  alignSelf={'flex-start'}
                  fontSize={'small'}
                >
                  Balance:
                  <Token amount={ftnBalance} toFtn={false} symbol={'FTN'} />
                </Box>
              </VStack>
              <HStack>
                <Button
                  variant={'solid'}
                  isLoading={isSubmitting}
                  type="submit"
                  disabled
                >
                  Submit
                </Button>
                <Button variant={'outline'} onClick={() => setShowFund(false)}>
                  Cancel
                </Button>
              </HStack>
            </HStack>
            <FormErrorMessage>
              {errors.amount && errors.amount.message}
            </FormErrorMessage>
          </FormControl>
        </VStack>
      </form>
    </Box>
  )
}
